<template>
  <div style="padding-top: 40px">
    <div>
      <p class="navadno-besedilo" style="padding-bottom: 5px;">
        Na tej strani lahko urejate svoje brezžično omrežje. Nastavite lahko ime omrežja, geslo (ključ)
        in ostale nastavitve omrežja.
        <br/>
        Ime in geslo Wifi omrežja lahko vsebujeta znake ABCDEFGHIJKLMNOPQRSTUVWZXYabcdefghijklmnopqrstuvwzxy0123456789_-
      </p>
    </div>
    <div v-if="!povezanoVOmrezje" class="obvestilo-splosno">
      Za urejanje nastavitev brezžičnega omrežja, prosimo priklopite napravo v omrežje.
    </div>
    <div>
      <div v-loading="nalaganjeWifiPodatkov" style="padding-top: 30px" v-if="JSON.stringify(wifiData) !== {}">
        <div v-if="nastavitveWifiSupport">
          <div>
            <el-form label-width="270px" :label-position="formaOrientacija" class="nova-vrstica-forma">

              <el-form-item v-if="!wifiData.options.meshController"
                            label="Omogoči brezžično omrežje 2,4GHz"
                            >
                <el-switch v-model="nastavitveEnabled"
                           class="custom-disabled-switch mobile-kljukica"
                           inactive-color="#ef7d00"
                           >
                </el-switch>
              </el-form-item>
              <el-form-item label="Ime omrežja 2,4GHz (SSID)" class="ime-omrezja">
                <el-input
                  :disabled="!nastavitveEnabled"
                  placeholder=""
                  v-model="nastavitveSSID"
                  class="velikost-input"/>
              </el-form-item>
              <el-form-item label="Ključ (geslo)" v-if="nastavitveBeaconType !== 'Open'" class="kljuc">
                <el-input
                  type="password"
                  v-model="nastavitvePSK"
                  :class="PasswordValid(nastavitvePSK) ? 'velikost-input' : 'velikost-input error'"
                  :disabled="!nastavitveEnabled"
                  value="FakePSW"
                  id="input-kljuc"
                  style="display:inline-block;">

                  <i slot="suffix" class="fa fa-eye-slash ikonaEyeSlashKljuc"
                     @click="PrikazKljuca('input-kljuc')" v-if="prikazeIkonoKljuc">
                  </i>
                  <i slot="suffix" class="fa fa-eye ikonaEyeKljuc"
                     @click="PrikazKljuca('input-kljuc')" v-else>
                  </i>
                </el-input>
                <i class="el-icon-warning">
                  <small>
                    Ključ mora vsebovati med 8 in 32 znakov.
                  </small>
                </i>
                <i class="el-icon-error" v-if="!PasswordValid(nastavitvePSK)">
                  <small>
                    Prosimo, vnesite med 8 in 32 znakov.
                    Uporabite lahko: ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxy0123456789_-.
                  </small>
                </i>
              </el-form-item>
              <el-form-item label="Varnost 2,4GHz"
                            v-if="!wifiData.options.meshController">
                <el-select :disabled="!nastavitveEnabled" v-model="nastavitveBeaconType" class="velikost-input">
                  <el-option v-for="(data,index) in wifiData.options.BeaconTypes"
                             :key="index"
                             :value="index"
                             :label="data">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Kanal 2,4GHz" v-if="!wifiData.options.meshController" >
                <el-select :disabled="!nastavitveEnabled" v-model="nastavitveChannel" class="velikost-input">
                  <el-option v-for="data in wifiData.options.PossibleChannels" :key="data"
                             :value="data" :label="data">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="!wifiData.options.meshController"
                            label="Skrij ime omrežja 2,4GHz"
                            class="mobile-kljukica" >
                <el-checkbox :disabled="!nastavitveEnabled" v-model="nastavitveSSIDHidden" class="mobile-checkbox">
                </el-checkbox>
              </el-form-item>
              <el-form-item label="Band Steering"

                            v-if="wifiData.data.WiFi5GSupported === 'true' && !wifiData.options.meshController" class="mobile-kljukica">
                <el-checkbox :disabled="!nastavitveEnabled" v-model="nastavitveBandsteering" class="mobile-checkbox" >
                </el-checkbox>
              </el-form-item>

              <!-- 5 GHz -->
              <div v-if="!nastavitveBandsteering && wifiData.data.WiFi5GSupported === 'true' && !wifiData.options.meshController">
                <div style="padding-top: 30px; padding-bottom: 20px;">
                  <hr class="hr-stil"/>
                </div>
                <el-form-item label="Omogoči brezžično omrežje 5GHz" >
                  <el-switch v-model="nastavitve5GHzEnabled" inactive-color="#ef7d00" class="mobile-kljukica"></el-switch>
                </el-form-item>
                <el-form-item label="Ime omrežja 5GHz" class="ime-omrezja">
                  <el-input
                    :disabled="!nastavitve5GHzEnabled"
                    placeholder=""
                    v-model="nastavitveSSID5GHz"
                    class="velikost-input" />
                </el-form-item>
                <el-form-item label="Ključ (geslo) 5GHz" v-if="nastavitveBeaconType5GHz !== 'Open'"
                              class="kljuc">
                  <el-input :disabled="!nastavitve5GHzEnabled" type="password" v-model="nastavitvePSK5Ghz"
                            :class="PasswordValid(nastavitvePSK5Ghz) ? 'velikost-input' : 'velikost-input error'"
                            value="FakePSW"
                            id="input-kljuc5GHz"
                            style="display:inline-block;">
                    <i slot="suffix" class="fa fa-eye-slash ikonaEyeSlashKljuc"
                       @click="PrikazKljuca('input-kljuc5GHz')" v-if="prikazeIkonoKljuc5GHz">
                    </i>
                    <i slot="suffix" class="fa fa-eye ikonaEyeKljuc"
                       @click="PrikazKljuca('input-kljuc5GHz')" v-else>
                    </i>
                  </el-input>
                  <i class="el-icon-warning">
                    <small>
                      Ključ mora vsebovati med 8 in 32 znakov.
                    </small>
                  </i>
                  <i class="el-icon-error" v-if="!PasswordValid(nastavitvePSK5Ghz)">
                    Prosimo, vnesite med 8 in 32 znakov.
                    Uporabite lahko: ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxy0123456789_-.
                  </i>
                </el-form-item>
                <el-form-item label="Varnost 5GHz">
                  <el-select :disabled="!nastavitve5GHzEnabled" v-model="nastavitveBeaconType5GHz"  class="velikost-input">
                    <el-option v-for="(data,index) in wifiData.options.BeaconTypes"
                               :key="index"
                               :value="index"
                               :label="data">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Kanal 5GHz" >
                  <el-select :disabled="!nastavitve5GHzEnabled" v-model="nastavitveChannel5G" class="velikost-input">
                    <el-option v-for="data in wifiData.options.PossibleChannels5G" :key="data"
                               :value="data" :label="data">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Skrij ime omrežja 5 GHz" class="mobile-kljukica">
                  <el-checkbox :disabled="!nastavitve5GHzEnabled" v-model="nastavitveSSID5GHzHidden" class="mobile-checkbox">
                  </el-checkbox>
                </el-form-item>
              </div>

            </el-form>
          </div>
          <div style="padding-top: 30px">
            <el-button type="primary" @click="PosodobiWifiConfig" class="gumb-potrdi">
              SHRANI SPREMEMBE
            </el-button>
          </div>
        </div>
        <div v-else-if="wifiData.length > 0 && !nastavitveWifiSupport">
          <p>
            Wifi ni podprt za ta tip naprave
          </p>
        </div>
      </div>
      <div>
        <InfoKomponentaMreznaOprema/>
      </div>
      <div style="padding-top: 40px">
        <hr class="hr-stil">
      </div>
      <div style="padding-top: 40px">
        <LegendaBrezzicnoOmrezje/>
      </div>
    </div>
  </div>
</template>
<script>
import {Checkbox, Input, Button, Form, FormItem, Select, Option, Collapse, CollapseItem} from 'element-ui'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import InfoKomponentaMreznaOprema from './InfoKomponentaMreznaOprema'
import LegendaBrezzicnoOmrezje from './LegendaBrezzicnoOmrezje'
import Vue from 'vue'

export default {
  name: 'wifi',
  mixins: [PrikazVsebine],
  props: {
    idIzbranaOprema: {},
    povezanoVOmrezje: false
  },
  emits: ['successNotification'],
  data () {
    return {
      title: 'Wifi',
      clientAgent: null,
      wifiData: {},
      nastavitveWifiSupport: '',
      nastavitveChannel: '',
      nastavitveChannel5G: '',
      nastavitveEnabled: '',
      nastavitve5GHzEnabled: '',
      nastavitveSSID: '',
      nastavitveSSID5GHz: '',
      nastavitveSSIDHidden: '',
      nastavitveSSID5GHzHidden: '',
      nastavitveBeaconType: '',
      nastavitveBeaconType5GHz: '',
      nastavitveBandsteering: '',
      nastavitvePSK: '',
      nastavitvePSK5Ghz: '',
      formaOrientacija: 'left',
      mejnaSirina: 1025,
      nalaganjeWifiPodatkov: false,
      prikazeIkonoKljuc: true,
      prikazeIkonoKljuc5GHz: true,
      hideTimer: null,
      hideTimer5G: null
    }
  },
  watch: {
    idIzbranaOprema: function () {
      if (this.idIzbranaOprema !== null) {
        this.GetWifiConfig()
      }
    },
    prikazeIkonoKljuc: function (val) {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer)
        this.hideTimer = null
      }
      if (!val) {
        this.hideTimer = setTimeout(() => {
          this.PrikazKljuca('input-kljuc')
          this.hideTimer = null
        }, 10000)
      }
    },
    prikazeIkonoKljuc5GHz: function (val) {
      if (this.hideTimer5G) {
        clearTimeout(this.hideTimer5G)
        this.hideTimer5G = null
      }
      if (!val) {
        this.hideTimer5G = setTimeout(() => {
          this.PrikazKljuca('input-kljuc5GHz')
          this.hideTimer5G = null
        }, 10000)
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetWifiConfig()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  components: {
    LegendaBrezzicnoOmrezje,
    InfoKomponentaMreznaOprema,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  methods: {
    PasswordValid (password) {
      return /^[A-Za-z0-9_-]{8,32}$/.test(password)
    },
    PrikazKljuca (id) {
      let element = document.getElementById(id)
      if (element.type === 'password') {
        element.type = 'text'
        if (id === 'input-kljuc') {
          this.prikazeIkonoKljuc = false
        } else if (id === 'input-kljuc5GHz') {
          this.prikazeIkonoKljuc5GHz = false
        }
      } else {
        element.type = 'password'
        if (id === 'input-kljuc') {
          this.prikazeIkonoKljuc = true
        } else if (id === 'input-kljuc5GHz') {
          this.prikazeIkonoKljuc5GHz = false
        }
      }
    },
    GetWifiConfig () {
      if (typeof this.idIzbranaOprema !== 'undefined') {
        this.nalaganjeWifiPodatkov = true
        let param = ['idOprema=' + this.idIzbranaOprema]
        this.clientAgent.postWsRequest(
          this,
          'tr069/wifi/info',
          param,
          param,
          'SetWifiInfo',
          'ShowErrorMsg')
      }
    },
    SetWifiInfo (podatki, param) {
      this.wifiData = podatki
      this.nastavitveWifiSupport = this.wifiData.data.WiFiSupported === 'true' ||
        this.wifiData.data.WiFi5GSupported === 'true'
      this.nastavitveChannel = this.wifiData.data.Channel
      this.nastavitveEnabled = this.wifiData.data.Enabled === 'true'
      this.nastavitveSSID = this.wifiData.data.SSID
      this.nastavitveSSIDHidden = this.wifiData.data.SSIDHidden === 'true'
      this.nastavitveBeaconType = this.wifiData.data.BeaconType
      this.nastavitvePSK = this.wifiData.data.PSK
      this.nastavitveBandsteering = this.wifiData.data.BandSteering === 'true'

      if (this.wifiData.data.WiFi5GSupported === 'true') {
        this.clientAgent.postWsRequest(
          this,
          'tr069/wifi/info5g',
          param,
          null,
          'SetWifi5GhzInfo',
          'ShowErrorMsg')
      } else {
        this.nastavitveChannel5G = ''
        this.nastavitve5GHzEnabled = ''
        this.nastavitveSSID5GHz = ''
        this.nastavitveSSID5GHzHidden = ''
        this.nastavitveBeaconType5GHz = ''
        this.nastavitvePSK5Ghz = ''
        this.nalaganjeWifiPodatkov = ''
        this.nalaganjeWifiPodatkov = ''
      }
    },
    SetWifi5GhzInfo (podatki) {
      Vue.set(this.wifiData.data, 'PossibleChannels5G', podatki.options.PossibleChannels)

      this.wifiData.options.PossibleChannels5G = podatki.options.PossibleChannels5G

      this.nastavitveChannel5G = podatki.data.Channel
      this.nastavitve5GHzEnabled = podatki.data.Enabled === 'true'
      this.nastavitveSSID5GHz = podatki.data.SSID
      this.nastavitveSSID5GHzHidden = podatki.data.SSIDHidden === 'true'
      this.nastavitveBeaconType5GHz = podatki.data.BeaconType
      this.nastavitvePSK5Ghz = podatki.data.PSK
      this.nalaganjeWifiPodatkov = false
    },
    PosodobiWifiConfig () {
      this.nalaganjeWifiPodatkov = true
      let param = ['idOprema=' + this.idIzbranaOprema]
      let authMode = ''
      if (this.nastavitveBeaconType !== 'Open') {
        authMode = 'PSKAuthentication'
      } else {
        authMode = 'None'
      }
      param.push('wifiEnable=' + encodeURI(this.nastavitveEnabled))
      param.push('channel=' + encodeURI(this.nastavitveChannel))
      param.push('ssid=' + encodeURI(this.nastavitveSSID))
      param.push('hidden=' + this.nastavitveSSIDHidden)
      param.push('beacontyp=' + encodeURI(this.nastavitveBeaconType))
      param.push('authMode=' + encodeURI(authMode))
      param.push('password=' + encodeURI(this.nastavitvePSK))

      param.push('bandsteering=' + encodeURI(this.nastavitveBandsteering))

      if (this.wifiData.data.WiFi5GSupported === 'true') {
        let authMode5g = ''
        if (this.nastavitveBeaconType5GHz !== 'Open') {
          authMode5g = 'PSKAuthentication'
        } else {
          authMode5g = 'None'
        }
        param.push('wifiEnable5ghz=' + encodeURI(this.nastavitve5GHzEnabled))
        param.push('channel5ghz=' + encodeURI(this.nastavitveChannel5G))
        param.push('ssid5ghz=' + encodeURI(this.nastavitveSSID5GHz))
        param.push('hidden5ghz=' + encodeURI(this.nastavitveSSID5GHzHidden))
        param.push('beacontyp5ghz=' + encodeURI(this.nastavitveBeaconType5GHz))
        param.push('authMode5ghz=' + encodeURI(authMode5g))
        param.push('password5ghz=' + encodeURI(this.nastavitvePSK5Ghz))
      }
      this.clientAgent.postWsRequest(
        this,
        'tr069/wifi/configure',
        param,
        null,
        'SetPosodobiWifiPodatke',
        'ErrPosodobiWifiPodatke')
    },
    SetPosodobiWifiPodatke () {
      this.$emit('successNotification')
      this.GetWifiConfig()
    },
    ErrPosodobiWifiPodatke (podatki) {
      this.nalaganjeWifiPodatkov = false
      this.ShowWarningMessage(podatki)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Nastavitve/MreznaOprema/wifi.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/tr069/Wifi.vue